import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import matchingStatusIcon from "assets/matching-status-icon.svg";
import { ANSpriteLogo } from "@answersnow/pkg-theme";

const MatchingStatus = {};

const MatchingLoading = () => (
  <Box textAlign="center">
    <ANSpriteLogo />

    <Typography component="h3" variant="subtitle1" align="center">
      Refreshing the queue.
    </Typography>

    <Typography component="p" variant="body2" align="center" color="text.secondary">
      We&apos;re just adding a few final touches. This may take a few moments.
    </Typography>
  </Box>
);

const MatchingRefreshing = () => (
  <Box textAlign="center">
    <ANSpriteLogo />

    <Typography component="h3" variant="subtitle1" align="center">
      Refreshing proposed matches.
    </Typography>

    <Typography component="p" variant="body2" align="center" color="text.secondary">
      The system is currently rerunning to find new potential matches. Please come back later.
    </Typography>
  </Box>
);

/**
 * @component
 * @returns {JSX.Element} MatchingStatus.Empty component
 */
const MatchingEmpty = () => {
  return (
    <Box textAlign="center">
      <img src={matchingStatusIcon} alt="Matching Status Icon" />

      <Typography component="h3" variant="subtitle1" align="center" mt={4}>
        The queue is empty!
      </Typography>

      <Typography component="p" variant="body2" align="center" color="text.secondary" mb={4}>
        It looks like there are no matches to review at the moment.
      </Typography>
    </Box>
  );
};

/**
 * @component
 * @returns {JSX.Element} MatchingStatus.NoFound component
 */
const MatchingNoFound = () => {
  return (
    <Box textAlign="center">
      <img src={matchingStatusIcon} alt="Matching Status Icon" />

      <Typography component="h3" variant="subtitle1" align="center" mt={4}>
        We couldn&apos;t find a match.
      </Typography>

      <Typography component="p" variant="body2" align="center" color="text.secondary" mb={4}>
        Looks like we&apos;re in short supply of Clinicians to find the best matches.
      </Typography>
    </Box>
  );
};

MatchingStatus.Loading = MatchingLoading;
MatchingStatus.Refreshing = MatchingRefreshing;
MatchingStatus.Empty = MatchingEmpty;
MatchingStatus.NoFound = MatchingNoFound;

export default MatchingStatus;
